import { ComponentChangeType } from "../types/";
import type { ChangedComponentsByChangeType } from "@certa/studio/api";

/** Util that returns whether the component should display component actions highlighter */
export const getHighlightingDetails = (
  componentTag: string,
  changedComponentTags: ChangedComponentsByChangeType
) => {
  if (changedComponentTags) {
    if (changedComponentTags.addedComponentTags.includes(componentTag)) {
      return { changeType: ComponentChangeType.ADDED };
    } else if (
      changedComponentTags.deletedComponentTags.includes(componentTag)
    ) {
      return { changeType: ComponentChangeType.DELETED };
    } else if (
      changedComponentTags.updatedComponentTags.includes(componentTag)
    ) {
      return { changeType: ComponentChangeType.UPDATED };
    } else if (changedComponentTags.hoveredComponent === componentTag) {
      return { changeType: ComponentChangeType.HOVERED };
    } else {
      return null;
    }
  } else {
    return null;
  }
};
